<template>
<div class="personal-info">
  <div class="card">
    <div class="title">{{$t('User.perInfo')}}</div>
    <el-form
      ref="form"
      :model="form"
      :rules="rules"
      label-position="top"
    >
      <el-row
        :gutter="20"
      >
        <el-col
          :xs="24"
          :sm="12"
          :md="12"
        >
          <el-form-item
            :label="$t('family_name')"
            prop="lastName"
          >
            <el-input
              :placeholder="$t('please_enter')"
              v-model="form.lastName"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col
          :xs="24"
          :sm="12"
          :md="12"
        >
          <el-form-item
            :label="$t('Register.lastName')"
            prop="familyName"
          >
            <el-input
              :placeholder="$t('please_enter')"
              v-model="form.familyName"
            ></el-input>
          </el-form-item>

        </el-col>
        <el-col
          :xs="24"
          :sm="12"
          :md="8"
        >
          <el-form-item
            :label="$t('Gender')"
            prop="gender"
          >
            <el-select
              style="width: 100%;"
              :placeholder="$t('please_enter')"
              v-model="form.gender"
            >
              <el-option
                v-for="(item,index) in sexList"
                :key="index"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col
          :xs="24"
          :sm="12"
          :md="8"
        >
          <el-form-item
            :label="$t('User.nationality')"
            prop="nationality"
          >
            <el-select
              style="width: 100%;"
              :placeholder="$t('please_enter')"
              v-model="form.nationality"
            >
              <el-option
                v-for="(item,index) in nationalityList"
                :key="index"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col
          :xs="24"
          :sm="12"
          :md="8"
        >
          <el-form-item
            :label="$t('User.birthday')"
            prop="birthday"
          >
            <el-date-picker
              style="width: 100%"
              v-model="form.birthday"
              type="date"
              :placeholder="$t('please_choose')"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
<!--点击下一步，保存数据并记录进度，
退出后重新进入自动定位到未填写的步骤-->
  <div class="btn-line">
    <el-button
      type="primary"
      @click="nextStepHandle"
      :loading="submitting"
      :disabled="submitting"
    >{{$t('root.next')}}</el-button>
  </div>
</div>
</template>

<script>
import { mapGetters } from 'vuex'
import { savePerfectInfoStep } from '@/api/userCenter.js';
import { getLocalStorage, changeTimestamp } from '@/utils/common';
import { showMessage } from '@/utils/common';
export default {
  name: "personalInfo",
  props: {
    allData:{
      type: Object,
      default(){
        return {

        }
      }
    },
    nationalityList: {
      type: Array,
      default(){
        return []
      }
    },
    sexList: {
      type: Array,
      default(){
        return []
      }
    }
  },
  data() {
    return {
      submitting: false,
      form: {
        familyName: '',
        lastName: '',
        gender: '',
        nationality: '',
        birthday: '',
      },
      rules: {
        familyName: [
          {
            validator: (rule, value, callback) => {
              if (!value || value.trim() === '') {
                callback(new Error(this.$t('User.nameNullMessage')));
              } else {
                callback();
              }
            },
            trigger: 'blur'
          }
        ],
        lastName: [
          {
            validator: (rule, value, callback) => {
              if (!value || value.trim() === '') {
                callback(new Error(this.$t('User.nameNullMessage')));
              } else {
                callback();
              }
            },
            trigger: 'blur'
          }
        ],
        gender: [
          { required: true, message: this.$t('please_select_gender'), trigger: 'change' }
        ],
        nationality: [
          { required: true, message: this.$t('please_select_nationality'), trigger: 'change' }
        ],
        birthday: [
          { required: true, message: this.$t('please_select_birthday'), trigger: 'change' }
        ],
      },
    }
  },
  computed: {
    ...mapGetters(['userInfo']),
  },
  watch:{
    allData(news, olds) {
      this.form.lastName = news.firstName;
      this.form.familyName = news.lastName;
      this.form.gender = news.gender || '1';
      this.form.nationality = news.nationality == null ? '1' : news.nationality;
      this.form.birthday = news.birthday || '';
    }
  },
  created(){
    this.$nextTick(() => {
      this.$refs['form'].clearValidate()
    })
  },
  methods: {
    changeTimestamp,
    parseString(parmas) {
      return parmas + '';
    },
    validateForm() {
      return new Promise((resolve) => {
        this.$refs.form.validate((valid) => {
          resolve(!!valid);
        });
      });
    },
    getParams(){
      let birthdayDate = this.changeTimestamp(this.form.birthday).split(' ')[0];
      return {
        firstName: this.form.lastName,
        lastName: this.form.familyName,
        gender: this.form.gender,
        nationality: this.form.nationality,
        birthday: birthdayDate,
      }
    },
    nextStepHandle() {
      if (this.submitting) return;
      this.submitting = true;
      this.$refs.form.validate((valid) => {
        if(valid){
          if (valid) {
            // 第一步没有了省市区三级,挪到了地址验证那里
            /*if(this.realMobile){
              if(this.form.liveCountry ==  '1'){
                if(!this.province && !this.city && !this.area){
                  showMessage(this,this.$t('User.regionNullMessage'));
                  return;
                }
              }
            }else {
              if(this.form.liveCountry ==  '1'){
                if(!this.form.region.length || (this.form.region.length && !this.form.region[0])){
                  showMessage(this,this.$t('User.regionNullMessage'));
                  return;
                }
              }
            }*/

            let Parmas = {
              profileProgress: 1,//
              ...this.getParams(),
            };
            /*if(this.realMobile){
              Parmas.homeProvince = this.province;
              Parmas.homeCity = this.city;
              Parmas.homeStreet = this.area;
            }*/
            savePerfectInfoStep({
              ...Parmas,
              id: this.userInfo.id
            }).then((res) => {
              this.$emit('next-step', 1);
            }).catch(() => {
            }).finally(() => {
              this.submitting = false;
            })
          }
          // 提交 ajax todo

        }else {
          this.submitting = false;
          // 滚动到第一个错误的表单项
          this.$nextTick(() => {
            const errorItem = this.$refs.form.$el.querySelector('.el-form-item.is-error');
            if (errorItem) {
              errorItem.scrollIntoView({
                behavior: 'smooth',
                block: 'center'
              });
            }
          });
          console.log('no-pass');
        }
      })

    }
  },
}
</script>

<style lang="scss" scoped>
.personal-info {
  .el-col {
    margin-bottom: 6px;
  }
  .btn-line {
    @media screen and (max-width: 768px) {
      display: flex;
      justify-content: flex-end;
    }
  }
}
</style>
